import Swiper from 'swiper/bundle';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

export default {
    name : 'swiper--product',

    init()
    {
        const items = document.querySelectorAll('.swiper--product');
        if (items.length) {
            setTimeout(
                this.run.bind(this), 100);
        }
    },
    setArrows(el){
        
        let img = el.querySelector("img");
        let buttons = el.querySelectorAll(".js-swiper-button");
       

        img?.addEventListener("load", e => {
            let imageHeight = img.clientHeight;
            let imageTop = img.getBoundingClientRect().top;
            let elTop = el.getBoundingClientRect().top;
            buttons.forEach(btn => {
                btn.style.top = (imageTop - elTop) + imageHeight / 2 + "px";
            });
        });
       
    },
    run ()
    {
        const collections = document.querySelectorAll('.swiper--product');

        if (!collections) {
            return false;
        }

        document.querySelectorAll('.js-swiper-nav-container').forEach(el=> {
            this.setArrows(el);
        });

        const sliderIds = [];
        collections.forEach( (element) => sliderIds.push(element.id));

        const sliders = [];

        if (sliderIds.length) {
            for (let i=0; i<sliderIds.length;i++) {
                sliders[i] = new Swiper('#'+sliderIds[i] , {
                        spaceBetween: 0,
                        slidesPerView: 1,
                        pagination : {
                            el:  '.'+sliderIds[i]+".swiper-pagination",
                            type: 'progressbar'
                        },
                        navigation: {
                            nextEl: '.'+sliderIds[i]+ ".swiper-button-next",
                            prevEl: '.'+sliderIds[i] + ".swiper-button-prev",
                        },
                    }
                );
            }
        }
    } // run

} // export